var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({class:_vm.getCls,attrs:{"color":"rgba(22, 27, 37, 0.5)","fab":"","text":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"size":"24"}},[_vm._v("mdi-close")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }